export const opportunityCreationStages = [
  'PROSPECT',
  'CONTACTED',
  'DEMO',
  'PROPOSAL',
  'NEGOTIATION',
];

export const opportunityStagesFromCatalog = catalog => {
  const openStages = Array.isArray(catalog)
    ? catalog
      .filter(stage => stage && !stage.outcome && stage.code)
      .map(stage => String(stage.code))
    : [];
  return openStages.length ? openStages : opportunityCreationStages;
};
